import React, { ReactElement, useState } from "react";
import { Form } from "react-bootstrap";
import useKeyboardShortcuts from "../../../contexts/KeyboardShortcutContext";
import useSelectionState, { Ticket } from "../../../pages/agent/selection-state";
import { ChatStatus, useHoldChatsMutation } from "../../../__generated__/api";
import Confirm from "../../confirm/Confirm";

export default function Hold(): ReactElement {
    const selectionState = useSelectionState();
    const [isShow, setShouldShow] = useState(false);
    const [holdChatsMutation] = useHoldChatsMutation();
    const [notes, setNotes] = useState("");

    const [lastOnHold, setLastOnHold] = useState<Ticket[]>([]);

    const hold = (tickets?: Ticket[]) => {
        const selection = tickets ?? selectionState
            .getSelection()
            .filter(ticket => ticket.status === ChatStatus.Assigned);

        setLastOnHold(selection);
        setShouldShow(true);
    };

    const doHold = async (note: string) => {
        const ids = lastOnHold.toIdList("id") as string[];
        await holdChatsMutation({
            variables: {
                ids,
                options: {
                    note,
                },
            },
        });

        setShouldShow(false);
        selectionState.closeCurrent();
    };

    useKeyboardShortcuts(shortcuts => {
        shortcuts.on({
            shortcut: "k+h",
            context: "default",
            description: "Hold the conversation",
            group: "Conversations",
            handler: () => hold(),
        });
    });

    selectionState.registerHold(tickets => {
        hold(tickets);
    });

    return (
        <Confirm
            shouldShow={isShow}
            onHide={() => setShouldShow(false)}
            confirmText="Hold"
            onConfirm={() => {
                doHold(notes);
            }}
        >
            <div>
                <h5 className="mb-4">
                    Put on Hold
                </h5>
                <Form.Group className="mt-4">
                    <Form.Label className="fw-bolder">
                        Notes
                        {" "}
                        <small className="text-light">(optional)</small>
                    </Form.Label>

                    <Form.Control
                        as="textarea"
                        value={notes}
                        onChange={evt => setNotes(evt.target.value)}
                    />
                    <Form.Text className="d-block">
                        Any notes you want to add before holding
                    </Form.Text>
                </Form.Group>
            </div>
        </Confirm>
    );
}

Hold.defaultProps = {
    refreshData: () => {
        // nothing
    },
};
